import React, { useState, useEffect } from "react";
import { useQueryClient } from "react-query";
import {
  validateOfficeMassUpload,
  downloadOfficeSettingsTemplate,
} from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import EditButton from "../../../../components/EditButton";
import HideButton from "../../../../components/HideButton";
import OfficeModal from "../../../../components/OfficeModal";
import SaveDataButton from "../../../../components/SaveDataButton";
import ShowButton from "../../../../components/ShowButton";
import Table from "../../../../components/tables/Table";
import { toast } from "../../../../components/toastNotification";
import { MassUploadExpandedRow } from "./MassUploadExpandedRow";
import { useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { PERMISSIONS } from "../../../PermissionsConstants";
import useMassUploadOfficeSettings from "../hooks/useMassUploadOfficeSettings";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import * as XLSXFiles from "xlsx";
import UploadFileButton from "../../../../components/UploadFileButton";
import TemplateButton from "../../../../components/TemplateButton";

const MassUpload = ({ isOpen, setMassUploadModal }) => {
  const user = useRecoilValue(accountAtom);
  const [xlsx, setXlsx] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("All");
  const [openModal, setOpenModal] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleClear, setToggleCleared] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [show, setShow] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [DisplayNote, setDisplayNote] = useState(false);
  const userAccount = useRecoilValue(accountAtom);
  const [, setIsBulkSelected] = useState(false);

  const deletePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_office_delete;

  const hasValidData =
    origData && origData?.filter((data) => data.isValid).length > 0;
  const [franchiseCheckBoxValue, setFranchiseCheckBoxValue] = useState(false);
  const [, setConfieCheckBoxValue] = useState(false);
  const queryClient = useQueryClient();
  // save mass upload
  const { mutate: massUploadOffice } = useMassUploadOfficeSettings();

  useEffect(() => {
    const scriptShim = document.createElement("script");
    scriptShim.async = true;
    scriptShim.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.3/shim.min.js";
    scriptShim.integrity =
      "824a6ade25af712b2dabb1dc9d30f3441b5b1652fd7fa43a9f6ba99607849a6334c1baf0085047e4d2692a06e4ed299af067d71ffdf7986225cc041c6d8d71b8"; //C0nF!esH1m //sha512
    scriptShim.crossOrigin = "anonymous";

    const scriptXLS = document.createElement("script");
    scriptXLS.async = true;
    scriptXLS.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.3/xlsx.full.min.js";
    scriptXLS.integrity =
      "ce7e2434109f7c48061d1a110f5d2082e827dd41a0d9bb3950be8e3adea03f7508aa287b5c177754cf32dab771212d7de2f03d8a19d685b0dfc8a8452fd8172f"; //C0nF!eXLs //sha512
    scriptXLS.crossOrigin = "anonymous";

    scriptXLS.onload = () => setXlsx(XLSXFiles);

    document.body.appendChild(scriptShim);
    document.body.appendChild(scriptXLS);

    let timer = setTimeout(() => setLoading(false), 5000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  function getOfficeTimeZone(url_Request) {
    var xhr = new XMLHttpRequest(); // create new XMLHttpRequest2 object
    return new Promise((resolve, reject) => {
      xhr.open("GET", url_Request, true); // open GET request
      xhr.onload = function () {
        if (xhr.status === 200) {
          // if Ajax request successful
          var output = JSON.parse(xhr.responseText);
          if (output.status === "OK") {
            resolve(output);
          }
        }
      };
      xhr.send();
    });
  }

  function getOfficeLocation(url_Request, async = true) {
    var xhr = new XMLHttpRequest(); // create new XMLHttpRequest2 object
    return new Promise((resolve, reject) => {
      xhr.open("GET", url_Request, async); // open GET request
      xhr.onload = function () {
        if (xhr.status === 200) {
          // if Ajax request successful
          var output = JSON.parse(xhr.responseText);
          if (output.status === "OK") {
            resolve(output);
          }
        }
      };
      xhr.send();
    });
  }

  const UploadFile = (e) => {
    if (e.target.files.length > 0) {
      setLoading(false);
      const reader = new FileReader();
      const excelFile = e.target.files[0];
      reader.onload = (e) => {
        const result = e.target.result;
        try {
          const readedData = xlsx.read(result, {
            type: "binary",
            sheetRows: 1,
          });
          const wsname = readedData.SheetNames[0];
          const ws = readedData.Sheets[wsname];
          /* Convert array to json*/
          const dataParse = xlsx.utils.sheet_to_json(ws, { header: 1 });

          if (
            dataParse[0].includes("Office Name required") &&
            dataParse[0].includes("Office Type required") &&
            dataParse[0].includes("Office Status required") &&
            dataParse[0].includes("Office Status Detail required") &&
            dataParse[0].includes("Brand ID required") &&
            dataParse[0].includes("Legal Entity License Number required") &&
            dataParse[0].includes("Phone (ex. (123) 456-7890) required") &&
            dataParse[0].includes("Address required") &&
            dataParse[0].includes("City required") &&
            dataParse[0].includes("State (ex. Arizona) required") &&
            dataParse[0].includes("Zip Code required") &&
            dataParse[0].includes("Country (ex. United States) required")
          ) {
            const wb = xlsx.read(result, {
              type: "binary",
              cellDates: true,
              dateNF: "YYYY-MM-DD",
            });
            const xData = xlsx.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);

            if (xData.length > 0) {
              setLoading(true);
              setDisplayNote(true);
              Promise.all(
                xData.map(async (office) => {
                  // Base object with common fields
                  const baseOfficeData = {
                    officeCode: office["Office Code required"],
                    Address: office["Address required"],
                    BrandName: office["Brand ID required"],
                    City: office["City required"],
                    Country: office["Country (ex. United States) required"],
                    LicenseNumber:
                      office["Legal Entity License Number required"],
                    OfficeName: office["Office Name required"],
                    OfficeStatusDetail: office["Office Status Detail required"],
                    OfficeStatus: office["Office Status required"],
                    OfficeType: office["Office Type required"],
                    PhoneNumber: office["Phone (ex. (123) 456-7890) required"],
                    State: office["State (ex. Arizona) required"],
                    ZipCode: office["Zip Code required"],
                    OfficeDepartmentName: office["Office Department"],
                    CreatedBy:
                      office[
                        "Account Owner/Created By (ex. youremail@confiegroup.com)"
                      ],
                  };

                  // Check if the required fields for geolocation are present
                  if (
                    !office["Address required"] ||
                    !office["City required"] ||
                    !office["Country (ex. United States) required"]
                  ) {
                    return {
                      ...baseOfficeData,
                      Geolocation: "",
                      ShippingAddressLatitude: "",
                      ShippingAddressLongitude: "",
                      ShippingTimeZone: "",
                      ShippingDaylightSavings: "",
                      ShippingLocation: "",
                    };
                  }

                  let URLGeo =
                    "https://maps.googleapis.com/maps/api/geocode/json?address=" +
                    office["Address required"] +
                    "%20" +
                    office["City required"] +
                    "%20" +
                    office["State (ex. Arizona) required"] +
                    "%20" +
                    office["Zip Code required"] +
                    "%20" +
                    office["Country (ex. United States) required"] +
                    "&key=" +
                    user?.googleTimezoneApiKey;

                  const geoData = await getOfficeLocation(URLGeo, true);
                  let locLattitude =
                    geoData && geoData.results[0]?.geometry?.location?.lat;
                  let locLongitude =
                    geoData && geoData.results[0]?.geometry?.location?.lng;
                  let geolocation = locLattitude + ", " + locLongitude;
                  let shippingLocation = geoData.results[0]?.formatted_address;

                  // TimeZone
                  const targetDate = new Date();
                  var timestamp =
                    targetDate.getTime() / 1000 +
                    targetDate.getTimezoneOffset() * 60;
                  const url_Request =
                    "https://maps.googleapis.com/maps/api/timezone/json?location=" +
                    geolocation +
                    "&timestamp=" +
                    timestamp +
                    "&key=" +
                    user?.googleTimezoneApiKey;

                  const timeZone = await getOfficeTimeZone(url_Request);

                  let shippingDaylightSavings =
                    timeZone.dstOffset > 0 ? true : false;
                  let shippingTimeZone = timeZone?.timeZoneName;

                  // Return the base object with geolocation and timezone fields
                  return {
                    ...baseOfficeData,
                    Geolocation: geolocation,
                    ShippingAddressLatitude: locLattitude,
                    ShippingAddressLongitude: locLongitude,
                    ShippingTimeZone: shippingTimeZone,
                    ShippingDaylightSavings: shippingDaylightSavings,
                    ShippingLocation: shippingLocation,
                  };
                })
              ).then((result) => {
                validateOfficeMassUpload(result)
                  .then((res) => {
                    const updatedData = res?.map((data, index) => {
                      return { ...data, id: index, expandRow: false };
                    });
                    setAllData(updatedData);
                    setOrigData(updatedData);
                    refreshTable(updatedData);
                    setLoading(false);
                  })
                  .catch((err) => {
                    setAllData([]);
                    setOrigData([]);
                    setLoading(false);
                    setDisplayNote(false);
                    toast.fire(
                      "Upload Failed",
                      "Invalid data in file.",
                      "error"
                    );
                  });
              });
            } else {
              setDisplayNote(false);
              setLoading(false);
              toast.fire(
                "Uploading Office Failed",
                "No data to upload, fields are empty.",
                "error"
              );
            }
          } else {
            setDisplayNote(false);
            setLoading(false);
            toast.fire(
              "Uploading Office Failed",
              "Invalid file, missing office required fields.",
              "error"
            );
          }
        } catch (e) {
          setDisplayNote(false);
          toast.fire("Upload Failed", "Cannot read file.", "error");
          setLoading(false);
        }
      };
      reader.readAsBinaryString(excelFile);

      e.target.value = null;
    }

    //setLoading(true);
  };

  const refreshTable = (tableData) => {
    if (selectedTab === "Invalid" || selectedTab === "Valid") {
      handleSelectedTab(selectedTab, tableData);
    }
  };

  const handleActions = (row, type) => {
    const updatedData = origData.map((d) => {
      if (d.id === row.id) {
        d.expandRow = !d.expandRow;
      }
      return d;
    });
    if (type === "Show") {
      setShow(true);
      setDisplayNote(false);
    } else if (type === "Hide") {
      setShow(false);
      setShowEdit(false);
      setAllData(updatedData);
      setDisplayNote(true);
      refreshTable(updatedData);
    } else if (type === "Edit") {
      setAllData(updatedData);
      setShow(false);
      setShowEdit(true);
      setDisplayNote(false);
      refreshTable(updatedData);
    }
  };

  const columns = [
    {
      name: "Findings",
      cell: (row) => {
        return (
          <div className="text-xs3  ">
            {row.isValid ? "Valid" : row.invalidDetails}
          </div>
        );
      },
    },
    {
      name: "Office Name",
      selector: (row) => {
        return <div className="text-xs3 ">{row.officeName}</div>;
      },
    },
    {
      name: "Office Type",
      selector: (row) => {
        return <div className="text-xs3 ">{row.officeType}</div>;
      },
    },
    {
      name: "Office Status",
      selector: (row) => {
        return <div className="text-xs3 ">{row.officeStatus}</div>;
      },
    },
    {
      name: "Office Status Details",
      selector: (row) => {
        return <div className="text-xs3 ">{row.officeStatusDetail}</div>;
      },
    },
    {
      name: "Brand Name",
      selector: (row) => {
        return <div className="text-xs3 ">{row.brandName}</div>;
      },
    },
    {
      name: "Legal Entity License",
      selector: (row) => {
        return <div className="text-xs3 ">{row.licenseNumber}</div>;
      },
    },
    {
      name: "Phone",
      selector: (row) => {
        return <div className="text-xs3 ">{row.phoneNumber}</div>;
      },
    },

    {
      name: "Actions",
      center: "true",
      cell: (row) => {
        return (
          <div className="flex 2xl:flex-row flex-col justify-center items-center">
            <div className="flex flex-row text-xs3 ">
              {row.expandRow && show ? (
                <HideButton
                  disabled={showEdit ? false : true}
                  buttonText="Hide"
                  onClick={() => {
                    handleActions(row, "Hide");
                  }}
                />
              ) : (
                ""
              )}

              <div className="flex flex-row flex-col justify-center items-center opacity-100 gap-x-2 space-x-1 space-y-1">
                {row.expandRow ? (
                  ""
                ) : (
                  <ShowButton
                    className={
                      (show || showEdit || selectedRows.length > 0
                        ? "opacity-50"
                        : "opacity-100") + ""
                    }
                    disabled={
                      showEdit || show || selectedRows.length > 0 ? true : false
                    }
                    buttonText="Show"
                    onClick={() => {
                      handleActions(row, "Show");
                    }}
                  />
                )}
                {row.expandRow ? (
                  ""
                ) : (
                  <EditButton
                    className={
                      (show || showEdit || selectedRows.length > 0
                        ? "opacity-50 w-16 lg:w-20"
                        : "opacity-100 w-16 lg:w-20") + ""
                    }
                    disabled={show || showEdit || selectedRows.length > 0}
                    buttonText="Edit"
                    onClick={() => {
                      handleActions(row, "Edit");
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  const tabs = ["All", "Valid", "Invalid"];

  const officeSettings = origData.map((x) => {
    return {
      ...x,
      IsFranchise:
        user.isFranchise && user.isNonFranchise
          ? franchiseCheckBoxValue
          : user.isFranchise,
    };
  });
  const SaveMassUploadData = () => {
    setOpenConfirm(true);
  };
  //Mass Upload save
  const ConfirmSave = () => {
    setUploading(true);
    massUploadOffice(officeSettings, {
      onSuccess: (res) => {
        if (res) {
          if (res.status === 200) {
            if (res.data.length > 0) {
              setUploading(false);
              setAllData(res.data);
              setOrigData(res.data);
              toast.fire(
                "Warning",
                "Not all data were saved. Please edit data with error(s)",
                "warning"
              );
            } else {
              resetAll();
              toast.fire(
                "Success ",
                "Your data has been saved successfully.",
                "success"
              );
            }
            queryClient.invalidateQueries("GetSFOffice");
          } else if (res.status !== 200) {
            setUploading(false);
            resetAll();
            if (
              res.data.message === "Failed sending of email" ||
              res.data.message === "Failed inserting of notification"
            ) {
              toast.fire(
                "Warning",
                "New office/s added successfully, but " + res.data.message,
                "warning"
              );
            } else {
              toast.fire(
                "Failed",
                "Failed to mass upload office! No data have been saved.",
                "error"
              );
            }
            queryClient.invalidateQueries("GetSFOffice");
          }
          setOpenConfirm(false);
        }
      },
      onError: (err) => {
        setUploading(false);
        resetAll();
        toast.fire(
          "Saving Failed",
          "We encountered an error when saving your data!",
          "error"
        );
      },
    });
  };

  const resetAll = () => {
    setUploading(false);
    setShow(false);
    setShowEdit(false);
    setDisplayNote(false);
    setData([]);
    setAllData([]);
    setSelectedRows([]);
    setOrigData([]);
    setSelectedTab("All");
    setFranchiseCheckBoxValue(true);
    setConfieCheckBoxValue(false);
  };
  const closeModal = () => {
    setMassUploadModal(false);
  };

  useEffect(() => {
    if (!isOpen) {
      setAllData([]);
    }
  }, [isOpen]);

  const downloadTemplate = () => {
    downloadOfficeSettingsTemplate().then((content) => {
      var url = window.URL.createObjectURL(content.data);
      let templateName =
        userAccount.isFranchise && !userAccount.isNonFranchise
          ? "MassUploadOfficeSettingsTemplate_Franchise.xlsx"
          : "MassUploadOfficeSettingsTemplate.xlsx";
      let tempLink = document.createElement("a");

      tempLink.href = url;
      tempLink.setAttribute("download", templateName);
      tempLink.click();
    });
  };

  const handleSelectedTab = (tab, data) => {
    setSelectedTab(tab);

    switch (tab) {
      case "All":
        return setAllData(origData);
      case "Valid":
        if (data !== null) {
          const valids = data.filter((data) => data.isValid);
          setAllData(valids);
        } else {
          const valids = origData.filter((data) => data.isValid);
          setAllData(valids);
        }
        return;
      case "Invalid":
        if (data !== null) {
          const invalids = data.filter((data) => !data.isValid);
          setAllData(invalids);
        } else {
          const invalids = origData.filter((data) => !data.isValid);
          setAllData(invalids);
        }
        break;
      default:
        return;
    }
  };

  const handleSelectedRowsChange = (state) => {
    setSelectedRows(state.selectedRows);
  };

  const handleDelete = () => {
    const ids = selectedRows.map((d) => d.id);
    const newData = origData.filter((d) => !ids.includes(d.id));
    setOrigData(newData);
    setAllData(newData);
    setOpenModal(false);
    setSelectedRows([]);
    setToggleCleared(!toggleClear);
    refreshTable(newData);
  };

  const updateRow = (currentData) => {
    const updatedData = origData.map((data) => {
      if (currentData.id === data.id) {
        data = currentData;
      }
      return data;
    });

    validateOfficeMassUpload(updatedData).then((res) => {
      if (res) {
        if (res.status) {
          toast.fire("Revalidate Failed", "Invalid data in file.", "error");
        } else {
          const restData = res?.map((data, index) => {
            return { ...data, id: index, expandRow: false };
          });

          setAllData(restData);
          setOrigData(restData);
          refreshTable(restData);
        }
      }

      setLoading(false);
    });

    setShow(false);
    setShowEdit(false);
  };

  return (
    <OfficeModal
      isOpen={isOpen}
      showEdit={showEdit}
      onClose={() => closeModal()}
      closeOutside={false}
    >
      <ConfirmBoxModal
        ModalTitle={"Mass Upload Office"}
        qConfirmation={`Are you sure you want to save these data?`}
        isOpen={openConfirm}
        onClose={() => {
          setUploading(false);
          setOpenConfirm(false);
        }}
        onClickFunction={() => {
          ConfirmSave();
        }}
      />
      <ConfirmBoxDelete
        ModalTitle="Delete Office"
        qConfirmation={"Are you sure you want to delete office(s)?"}
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        onClickFunction={() => {
          handleDelete();
          setDisplayNote(true);
        }}
      />
      <div>
        <div className="font-bold text-xl flex items-center m-2">
          <div className="text-base text-primary font-bold">
            Office Settings Mass Upload
          </div>
          <div className="ml-auto flex items-center ">
            <TemplateButton
              onClick={downloadTemplate}
              btnClassName={
                selectedRows.length > 0 || show || showEdit
                  ? "opacity-50"
                  : "opacity-50"
              }
              disabled={
                selectedRows.length > 0 || show || showEdit ? true : false
              }
            />
            <UploadFileButton
              onChange={UploadFile}
              disabled={
                selectedRows.length > 0 || show || showEdit || loading
                  ? true
                  : false
              }
            />
          </div>
        </div>
        <div className="mt-2 h-1 w-full border-b-4 border-secondary" />

        <div>
          <div className="flex items-end ">
            {tabs.map((tab) => {
              return (
                <button
                  onClick={() => handleSelectedTab(tab, null)}
                  className={`border-b-4 font-medium text-sm text-tertiary cursor-pointer transition py-3 px-5  
                     ${
                       selectedTab === tab
                         ? "border-primary font-bold bg-gray-50"
                         : "border-transparent hover:bg-gray-50 "
                     }`}
                >
                  {tab}
                </button>
              );
            })}

            {!showEdit &&
              !show &&
              selectedTab !== "Invalid" &&
              hasValidData && (
                <div className="ml-auto">
                  <SaveDataButton
                    className={
                      (show || showEdit || selectedRows.length > 0
                        ? "opacity-50 cursor-not-allowed border"
                        : "opacity-100") + ""
                    }
                    disabled={show || showEdit || selectedRows.length > 0}
                    onClick={SaveMassUploadData}
                    buttonValue={uploading ? "Saving..." : "Save Data"}
                  ></SaveDataButton>
                </div>
              )}
          </div>
          <div className="flex justify-between mt-3 ">
            {DisplayNote && data.length > 0 && (
              <div className="text-secondary italic text-xs3 ">
                <p className="font-bold italic inline-block mr-1">Note: </p>
                Tick the box to delete some data.
              </div>
            )}
            {user.isFranchise &&
              user.isNonFranchise &&
              DisplayNote &&
              data.length > 0 && (
                <div className="flex flex-row gap-2">
                  <div className="flex flex-row items-center gap-2 px-2">
                    <label className="flex text-xs lg:justify-end sm:justify-start">
                      Franchise :
                    </label>
                    <input
                      type="checkbox"
                      className={`w-4 h-4 border-gray-50`}
                      onChange={(e) => {
                        //  clickcode
                        setFranchiseCheckBoxValue(!franchiseCheckBoxValue);
                      }}
                    />
                  </div>
                </div>
              )}
          </div>
          <div
            className={`mt-4 box-shadow ${
              showEdit || show ? `w-auto h-80 overflow-auto` : ``
            }`}
          >
            <Table
              data={allData}
              columns={columns}
              loading={loading}
              selectableRows={DisplayNote && data.length > 0 ? true : false}
              selectedRows={selectedRows}
              onSelectedRowsChange={handleSelectedRowsChange}
              setOpenModal={setOpenModal}
              clearSelectedRows={toggleClear}
              expandableRows={true}
              setIsBulkSelected={setIsBulkSelected}
              expandableRowsComponent={(row) => (
                <MassUploadExpandedRow
                  data={row.data}
                  setShow={setShow}
                  isEdit={showEdit}
                  show={show}
                  updateRow={(data) => updateRow(data)}
                  setShowEdit={setShowEdit}
                  setDisplayNote={setDisplayNote}
                  handleActions={handleActions}
                />
              )}
              expandableRowExpanded={(row) => row.expandRow}
              deletePermission={deletePermission}
            />
          </div>
        </div>
      </div>
    </OfficeModal>
  );
};

export default MassUpload;
